module.exports = __webpack_public_path__ + "img/box-money.e5a3c9a0.svg";